import { css } from "@emotion/react";

import { formatPriceToBeInCurrency } from "@zapier/currency";
import { Colors } from "@zapier/design-system";

import { Currency, Plan } from "@/types";
import { getKFormat } from "@/utils";

type TaskLimitDropdownListItemProps = {
  /** The currency to use for pricing information. */
  currency: Currency;
  /** For annual, prices are divided by 12 so we display /month price */
  isAnnual: boolean;
  /** The `TaskLimitVariant` object to pull data from. */
  plan: Plan;
};

const Styles = {
  currency: css`
    color: ${Colors.blueJeans};
    font-weight: 700;
  `,

  muted: css`
    color: ${Colors.neutral700};
  `,

  root: css`
    display: flex;
    flex-direction: column;
    font-weight: normal;
    padding: 4px 0;
  `,

  tasks: css`
    color: ${Colors.neutral800};
    font-weight: 600;
  `,
};

/**
 * An individual item in a `TaskLimitDropdown`.
 */
export const TaskLimitDropdownListItem = ({
  currency,
  isAnnual,
  plan,
}: TaskLimitDropdownListItemProps) => {
  const amount = isAnnual ? plan.amount / 12 : plan.amount;
  const formattedMonthlyPayment = formatPriceToBeInCurrency(
    amount,
    currency,
    true,
    {
      maxDecimals: 2,
      minDecimals: 0,
      useRelativeRounding: false,
    }
  );

  return (
    <span css={Styles.root}>
      <span css={Styles.currency}>{formattedMonthlyPayment}</span>
      <span>
        <span css={Styles.tasks}>{getKFormat(Number(plan.tasks))} tasks </span>
        <span css={Styles.muted}>/mo</span>
      </span>
    </span>
  );
};
